import { Component, OnInit } from '@angular/core';
import { WorkOrderDashboardModalService } from '../service/work-order-dashboard-modal.service';
import { WorkOrderStatus } from '../constants/work-order-status';
import { ThemeService } from '../service/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { IotService } from '../service/iot.service';

@Component({
    selector: 'app-work-order-dashboard-modal',
    templateUrl: './work-order-dashboard-modal.component.html',
    styleUrls: ['./work-order-dashboard-modal.component.css', '../../global-elements.css'],
    standalone: false
})
export class WorkOrderDashboardModalComponent implements OnInit{
  public selectedStatus: string = '';
  public selectedDate: string = '';
  public selectedDescription: string = '';
  public selectedComment: string = '';

  public statusArray: any[] = [...WorkOrderStatus];

  constructor(public workOrderModalService: WorkOrderDashboardModalService,
    public theme: ThemeService,
    private iotService: IotService){

  }

  async ngOnInit() {
    this.selectedComment = this.workOrderModalService.selectedWorkOrder.comment;
    this.selectedDate = this.toDatetimeLocal(Number(this.workOrderModalService.selectedWorkOrder.work_order_deadline));
    this.selectedDescription = this.workOrderModalService.selectedWorkOrder.description;
    this.selectedStatus = this.statusArray.find(s => s.label === this.workOrderModalService.status)?.value ?? ''
  }

  convertTimestamp(timestamp: string){
    return this.iotService.convertTimestamp(Number(timestamp));
  }

  // Format our unix timestamps to a string our datetime-local input can read
  toDatetimeLocal(value: string | number | Date): string {
    const date = new Date(value);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }
}
